import cx from 'classnames';
import { counter_ENTRIES, counter_RATINGS } from 'mk/autogenerated/translations/ProductBuyerHeader.20582b37dbe0e165547409a1ac714d02'
import { BuyerEntity } from 'mk2/apps/bazaar/schemas';
import { bazaarSellerReviewsFromSellersUrl, bazaarSellerUrl } from 'mk2/apps/bazaar/urls';
import { Dot } from 'mk2/components/Dot';
import { Link } from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import styles from './ProductBuyerHeader.mscss';

interface OwnProps {
    className?: string;
    buyer: BuyerEntity;
}

type Props = OwnProps;

const ProductBuyerHeader: React.FunctionComponent<Props> = ({ className, buyer }) => {
    return (
        <div className={cx(styles.ProductBuyerHeader, className)}>
            <span className={styles.ProductBuyerHeader__username}>{buyer.user.username}</span>
            <Dot />
            <Link to={url(bazaarSellerUrl, {username: buyer.user.username})}>
                {interpolate(counter_ENTRIES, {
                    counter: buyer.seller.productsCount,
                    count: buyer.seller.productsCount,
                })}
            </Link>
            <Dot />
            <Link to={url(bazaarSellerReviewsFromSellersUrl, {username: buyer.user.username})}>
                {interpolate(counter_RATINGS, {
                    counter: buyer.seller.reviewsCount,
                    count: buyer.seller.reviewsCount,
                })}
            </Link>
        </div>
    );
};

ProductBuyerHeader.displayName = 'ProductBuyerHeader';

export default React.memo<Props>(ProductBuyerHeader);
